export const FORMAT_GROUP_CODE = 'format';
export const FORMAT_PAPER_COMPOSITE_CODE = `${FORMAT_GROUP_CODE}:paper`;
export const FORMAT_DIGITAL_COMPOSITE_CODE = `${FORMAT_GROUP_CODE}:digital`;
export const FORMAT_PAPER_DIGITAL_COMPOSITE_CODE = `${FORMAT_GROUP_CODE}:paperAndDigital`;
